/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG} from '../../../helpers'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'
import {useIntl} from 'react-intl'
import {useAccount} from '../../../../hooks/useAccount'

const ToolbarCreateApp: FC = () => {
  const intl = useIntl()
  const {classes} = useLayout()
  const {isOwner} = useAccount()

  return (
    <div className='toolbar' id='kt_toolbar'>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
        <DefaultTitle />
        {isOwner && (
          <div className='d-flex align-items-center py-1'>
            <a
              href='#'
              className='btn btn-sm btn-primary'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_create_app'
              id='kt_toolbar_primary_button'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr009.svg' className='svg-icon-muted svg-icon-1x' />
              {intl.formatMessage({id: 'APPS.MODAL.CREATE.BUTTON'})}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export {ToolbarCreateApp}
